var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"manage-department-title title-tab"},[_vm._v(" รายการบริการของฉัน ")])
}
var staticRenderFns = []

export { render, staticRenderFns }